import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ConfigsProvider, ConfigContext } from "react-builder";

@AttributeGroup({ title: 'Certificate', blockName: 'Certificate', module: 'elearning' })
export class CertificateAttributes extends Attribute {


    @AttributeProperty({ type: 'String' })
    name: string = 'John Doe';

    @AttributeProperty({ type: 'String' })
    date: string = '10/03/2023';

    @AttributeProperty({ type: 'String' })
    title: string = 'BASIC LEVEL';

    @AttributeProperty({ type: 'Image' })
    image?: string;

    @AttributeProperty({ type: 'String' })
    dynamicImage?: string;
}

const CertificateTheme = styled.div((props: { attributes: CertificateAttributes }) => `

    ${props.attributes.toCSS()}

    canvas{
        width: 100%;
        height: auto;
    }

`);

function Certificate(props: ComponentProps<CertificateAttributes>) {

    const canvas = React.createRef<HTMLCanvasElement>();
    const content = useContext(ConfigContext);

    const [width, setWidth] = useState<number>(1000);
    const [height, setHeight] = useState<number>(1500);
    const [img, setImage] = useState<HTMLImageElement>();

    useEffect(() => {

        const link: HTMLLinkElement = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap';
        link.rel = "stylesheet";
        link.onload = () => {
            setTimeout(() => {
                loadImage();
            }, 10);
        }

        document.head.append(link);
        // var myFont = new FontFace('myFont', 'url(https://fonts.gstatic.com/s/greatvibes/v15/RWmMoKWR9v4ksMfaWd_JN9XLiaQ6DQ.woff2)');

        // myFont.load().then((font) => {

        // with canvas, if this is ommited won't work
        // document.fonts.add(font);
        // });

    }, []);

    useEffect(() => {
        loadImage();
    }, [props.attributes]);
    useEffect(() => {
        drawCertificate();
    }, [img]);

    const loadImage = () => {
        if (!props.attributes.image) return;

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = props.attributes.dynamicImage ? content.parseContent(props.attributes.dynamicImage) : props.attributes.image;

        img.onload = (e) => {

            setImage(img);
        }
    }

    const drawCertificate = () => {

        console.log('drawing...');

        if (!img || !canvas.current) return;
        // adjust canvas to image size

        canvas.current.width = img?.naturalWidth;
        canvas.current.height = img?.naturalHeight;

        const context = canvas.current?.getContext('2d');
        if (!canvas.current || !context) return;

        context?.drawImage(img, 0, 0);

        // our code here
        context.font = "70px 'Great Vibes'"; // set font
        context.textAlign = "center"; // center text
        context.fillText(content.parseContent(props.attributes.name), canvas.current.width / 2, 570);

        context.font = "12px Tahoma bold"; // set font
        context.textAlign = "center"; // center text
        context.fillText(content.parseContent(props.attributes.title), canvas.current.width / 2, 820);

        context.font = "30px Tahoma normal"; // set font
        context.textAlign = "center"; // center text
        context.fillText(content.parseContent(props.attributes.date), canvas.current.width / 2 - 275, 790);

    }

    const download = () => {
        // Convert our canvas to a data URL
        let canvasUrl = canvas.current?.toDataURL();

        // validate
        if (!canvasUrl) return;

        // Create an anchor, and set the href value to our data URL
        const createEl = document.createElement('a');
        createEl.href = canvasUrl;

        // This is the name of our downloaded file
        createEl.download = "download-this-canvas";

        // Click the download button, causing a download, and then remove it
        createEl.click();
        createEl.remove();
    }

    return (
        <CertificateTheme {...props}>
            <ConfigsProvider configJson={{ certificate: { download } }}  >
                <>
                    {props.children}
                </>
            </ConfigsProvider>
            <canvas ref={canvas} />
        </CertificateTheme>
    )
}


Certificate.prototype.Props = CertificateAttributes;


export default Certificate;